import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Megaphone, X } from "lucide-react";
import api from "../lib/api";

export default function AnnouncementBanner() {
  const [ann, setAnn] = useState(null);

  useEffect(() => {
    api.get("/announcements/active").then(({ data }) => setAnn(data || null)).catch(() => {});
  }, []);

  if (!ann) return null;

  const dismiss = async () => {
    setAnn(null);
    await api.post(`/announcements/${ann.id}/dismiss`).catch(() => {});
  };

  return (
    <section className="card-base p-4 flex items-start gap-3 border-sage-200 bg-sage-50/60" data-testid="announcement-banner">
      <div className="w-9 h-9 rounded-xl bg-sage-100 text-sage-600 grid place-items-center shrink-0"><Megaphone size={16} /></div>
      <div className="flex-1 min-w-0">
        <div className="font-heading font-semibold" data-testid="announcement-banner-title">{ann.title}</div>
        <div className="text-sm text-ink-600 mt-0.5 line-clamp-2">{ann.body}</div>
        <Link to={`/announcements/${ann.id}`} className="text-sm font-semibold text-sage-600 mt-1.5 inline-block" data-testid="announcement-banner-open">
          Read more
        </Link>
      </div>
      <button onClick={dismiss} className="text-ink-400 hover:text-ink-700" aria-label="Dismiss" data-testid="announcement-banner-dismiss"><X size={18} /></button>
    </section>
  );
}
